<template>
 <page>
   
  
   <head-nav :title="$t('language.latest_albums')">
    <icon-button-hamburger slot="left"></icon-button-hamburger>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>


  <scroll-page :pull-reload="true">
    <page-padding>
      <button-action v-if="computeUserAccess" :to="'/group/0/photoalbum/add/'" title="language.add_photoalbum" ></button-action>
    </page-padding>
    

    <list-albums/>
  </scroll-page>

   </page>
</template>

<script>

import { mapState } from 'vuex';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding.vue';
import ListAlbums from '../components/albums/ListAlbums';
import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHome from '../components/buttons/IconButtonHome';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger';
import ScrollPage from '../components/ScrollPage.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';

export default {
  name: 'global-photoalbum-page',
  data:function(){
    return{
      
    }
  },
  computed:{
     ...mapState([
       'groups','appSettings'
       ]),
       computeUserAccess(){
         
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }

         return false;
       }
  },
  components: {
    ButtonAction,
    PagePadding,
    ListAlbums,
    Page,
    HeadNav,
    IconButtonHome,
    IconButtonHamburger,
    ScrollPage,
  },
  methods:{ 
  },// methods{}
  created(){
  }
}

    
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
